export const GET_PARAMS = {
  popup: 'popup',
  notificationId: 'notification-id',
}

export const GET_ENUMS = {
  popup: {
    signin: 'signin',
    test: 'test',
    profileInfo: 'profileInfo',
  },
}
